// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/Directory.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  max-width: 100px;
  margin: auto;
  padding: 10px;
}

.form {
  display: flex;
  flex-direction: column;
}

.form div {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.form label {
  margin-right: 15px;
}

.form input, .form select {
  padding: 8px;
  border: 1px solid #41313138;
  border-radius: 4px;
  flex-grow: 1;
}

.form button {
  padding: 5px 10px;
  background-color: #134274;
  color: rgb(255, 255, 255);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8em;
  margin-left: 10px;
}

.form button:hover {
  background-color: #6d7985;
}

.profile-display {
  margin-top: 20px;
  font-size: 0.9em;
}

.btn {
  padding: 8px 15px;
  margin: 5px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.update-btn {
  background-color: #4CAF50;
  color: white;
}

.delete-btn {
  background-color: #f44336;
  color: white;
}

.cancel-btn {
  background-color: #f0f0f0;
  color: black;
}

.btn:hover {
  opacity: 0.8;
}

.publication-list {
  font-size: 0.9em;
  position: relative; /* Ensure relative positioning for absolute children */
}

.publication-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #231d73;
  padding: 5px;
}

.publication-details {
  flex-grow: 1;
}

.publication-controls {
  display: flex;
  gap: 10px;
}

.add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 20px;
  line-height: 20px;
  padding: 0;
  position: absolute;
  right: 20px;
  bottom: 10px;
  background-color: #4CAF50;
  color: white;
  cursor: pointer;
}

.add-btn:hover {
  background-color: #3e8e41;
}


/* ... previous CSS styles ... */

.publication-list {
  font-size: 0.9em;
  position: relative; /* Ensure relative positioning for absolute children */
  padding-bottom: 40px; /* Add padding to accommodate the '+' button */
}

.publication-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #5d5b83;
  padding: 5px;
}

.publication-details {
  flex-grow: 1;
}

.publication-controls {
  display: flex;
  gap: 10px;
}

/* Modifications for the plus button */
.add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px; /* Adjusted width for a rectangle shape */
  height: 35px; /* Height for the rectangle */
  border-radius: 4px; /* Less rounded corners */
  font-size: 20px;
  line-height: 15px;
  padding: 10;
  position: absolute;
  right: 20px;
  bottom: 10px;
  background-color: #ffffff; /* Blue background */
  color: white;
  cursor: pointer;
  border: none;
}

.add-btn:hover {
  background-color: #fafdff; /* Darker blue for hover effect */
}

/* Ensure there is enough space at the bottom of the publication list for the button */
.publication-list {
  padding-bottom: 50px; /* Adjust padding to accommodate the button */
}

/* Styling for both Add and Modify modals */
.modal {
  position: fixed;
  top: 10%;
  left: 25%;
  right: 25%;
  background-color: rgb(157, 117, 117);
  padding: 20px;
  border: 1px solid rgb(110, 63, 63);
  box-shadow: 0px 0px 10px rgba(3, 0, 0, 0.841);
  overflow: auto; /* Allows scrolling if content is too long */
  max-height: 80%; /* Maximum height */
  resize: both; /* Make the modal resizable */
  z-index: 1000; /* Ensure it's above other elements */
}

.modal h3 {
  margin-top: 1;
}

.modal textarea {
  width: 100%;
  min-height: 500px;
  margin-top: 100px;
}

.modal button {
  margin-top: 10px;
}

/* If using an h3 tag for publication types */
h3 {
  font-size: 1.2em; /* Adjust the size as needed */
  font-weight: bold; /* Makes the text bold */
}

/* If using a specific class, e.g., .publication-type */
.publication-type {
  font-size: 1em; /* Adjust the size as needed */
  font-weight: bold; /* Makes the text bold */
}
/* Modal for Adding Publications */
.add-publication-modal {
  position: fixed;
  top: 10%;
  left: 25%;
  background-color: white;
  padding: 20px;
  border: 1px solid rgb(90, 62, 62);
  width: 50%;
  box-shadow: 0px 0px 10px rgba(33, 7, 7, 0.77);
}

/* Text area within the Add Publication Modal */
.add-publication-modal textarea {
  width: 100%;
  min-height: 100px;
  margin-top: 10px;
}



/* FacultyProfileDetails.css */

/* Style for bold titles in the faculty profile */
.faculty-profile p strong {
  font-weight: bold;
}






/*Image Hears*/
.faculty-login {
  background-color: #140c3d;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 70vh;
}

.faculty-login h1 {
  font-size: 38px;
  color: #dddae4;
  text-align: center;
  margin-bottom: 20px;
}



.container form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container input[type="text"],
.container input[type="password"] {
  width: 50%;
  padding: 5px;
  margin: 5px 0;
  border: 1px solid #452222;
  border-radius: 5px;
}

.container button {
  background-color: #193655e0;
  color: #ffffff;
  padding: 7px 15px;
  border: none;
  scroll-padding: 10px;
  margin: 5px 0;
  border-radius: 5px;
  cursor: pointer;
  font-size: 15px;
}

.container button:hover {
  background-color: #140a34;
}


.faculty-login header {
 
    display: flex;
    flex-direction: column;
    justify-content: flex-end; /* Aligns content to the bottom */
    text-align: end; /* Centers the text horizontally */
    background-size: cover; /* Cover the entire header area */
    background-position: center; /* Center the background image */
    height: 200px; /* Increase this value to adjust the height */
    padding: 10px; /* Adjust padding as needed */
  }

  .faculty-directory header {
    background-image: linear-gradient(rgba(218, 218, 240, 0.322), rgba(0, 0, 0, 0.945)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    
      display: flex;
      flex-direction: column;
      justify-content: flex-end; /* Aligns content to the bottom */
      text-align: end; /* Centers the text horizontally */
      background-size: cover; /* Cover the entire header area */
      background-position: center; /* Center the background image */
      height: 400px; /* Increase this value to adjust the height */
      padding: 10px; /* Adjust padding as needed */
    }







.faculty-name {
  font-size: 16px;
  font-weight: bold;
}

.faculty-designation {
  font-size: 14px;
}

.faculty-department {
  font-size: 14px;
  color: #3e77b4; /* Navy blue */
}

.faculty-contact p {
  margin: 5px 0;
  display: flex;
  align-items: center;
}

.fa-envelope, .fa-phone {
  margin-right: 10px;
}

.faculty-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.faculty-member {
  flex-basis: calc(33.33% - 10px);
  margin-right: 10px;
  margin-bottom: 20px;
  border-right: 2px solid #cba2a2;
}

.faculty-member:last-child {
  border-right: none; /* Remove border for the last element */
}

.filter-section {
  margin-bottom: 20px; /* Adjust as needed for spacing */
}

.department-select {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid #542c2c;
}

.department-select optgroup {
  font-weight: bold;
  font-size: 16px;
}

/* Custom scrollbar styles */
.department-select::-webkit-scrollbar {
  width: 10px;
}

.department-select::-webkit-scrollbar-track {
  background: #813737;
}

.department-select::-webkit-scrollbar-thumb {
  background: #f12222;
}

.department-select::-webkit-scrollbar-thumb:hover {
  background: #6b38ca;
}



.alphabet-header {
  font-weight: bold;
  font-size: 1.5em;
}


.faculty-register {
  margin-top: 100px; /* Adjust the value as needed for the space */
  text-align: center; /* Optional: Center the content */
}

.faculty-register h2 {
  font-size: 1.5rem; /* Styling for the heading */
  margin-bottom: 20px; /* Space below the heading */
}

.faculty-register form {
  display: flex;
  flex-direction: column;
  gap: 15px; /* Space between form fields */
  max-width: 400px; /* Limit the form width */
  margin: 0 auto; /* Center the form */
}

.faculty-register input,
.faculty-register select {
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.faculty-register button {
  padding: 10px 15px;
  font-size: 1rem;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.faculty-register button:hover {
  background-color: #0056b3;
}

.faculty-register .role-selection,
.faculty-register .department-selection {
  text-align: left; /* Aligns labels and inputs */
}

.faculty-register .error-message {
  color: red;
  font-size: 0.9rem;
  margin-top: 10px;
}

.faculty-register .success-message {
  color: green;
  font-size: 0.9rem;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/GenericStyles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB,EAAE,sDAAsD;AAC5E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,gCAAgC;;AAEhC;EACE,gBAAgB;EAChB,kBAAkB,EAAE,sDAAsD;EAC1E,oBAAoB,EAAE,8CAA8C;AACtE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,yCAAyC;EACvD,YAAY,EAAE,6BAA6B;EAC3C,kBAAkB,EAAE,yBAAyB;EAC7C,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA,sFAAsF;AACtF;EACE,oBAAoB,EAAE,6CAA6C;AACrE;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,kCAAkC;EAClC,6CAA6C;EAC7C,cAAc,EAAE,4CAA4C;EAC5D,eAAe,EAAE,mBAAmB;EACpC,YAAY,EAAE,6BAA6B;EAC3C,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB,EAAE,8BAA8B;EAChD,iBAAiB,EAAE,wBAAwB;AAC7C;;AAEA,uDAAuD;AACvD;EACE,cAAc,EAAE,8BAA8B;EAC9C,iBAAiB,EAAE,wBAAwB;AAC7C;AACA,kCAAkC;AAClC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EACjC,UAAU;EACV,6CAA6C;AAC/C;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;;;AAIA,8BAA8B;;AAE9B,iDAAiD;AACjD;EACE,iBAAiB;AACnB;;;;;;;AAOA,cAAc;AACd;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;IAEI,aAAa;IACb,sBAAsB;IACtB,yBAAyB,EAAE,iCAAiC;IAC5D,eAAe,EAAE,kCAAkC;IACnD,sBAAsB,EAAE,iCAAiC;IACzD,2BAA2B,EAAE,gCAAgC;IAC7D,aAAa,EAAE,6CAA6C;IAC5D,aAAa,EAAE,6BAA6B;EAC9C;;EAEA;IACE,4HAAkH;;MAEhH,aAAa;MACb,sBAAsB;MACtB,yBAAyB,EAAE,iCAAiC;MAC5D,eAAe,EAAE,kCAAkC;MACnD,sBAAsB,EAAE,iCAAiC;MACzD,2BAA2B,EAAE,gCAAgC;MAC7D,aAAa,EAAE,6CAA6C;MAC5D,aAAa,EAAE,6BAA6B;IAC9C;;;;;;;;AAQJ;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA;EACE,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB,EAAE,6CAA6C;EAChE,kBAAkB,EAAE,iCAAiC;AACvD;;AAEA;EACE,iBAAiB,EAAE,4BAA4B;EAC/C,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,8BAA8B;EACzC,gBAAgB,EAAE,yBAAyB;EAC3C,cAAc,EAAE,oBAAoB;AACtC;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".form-container {\r\n  max-width: 100px;\r\n  margin: auto;\r\n  padding: 10px;\r\n}\r\n\r\n.form {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.form div {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.form label {\r\n  margin-right: 15px;\r\n}\r\n\r\n.form input, .form select {\r\n  padding: 8px;\r\n  border: 1px solid #41313138;\r\n  border-radius: 4px;\r\n  flex-grow: 1;\r\n}\r\n\r\n.form button {\r\n  padding: 5px 10px;\r\n  background-color: #134274;\r\n  color: rgb(255, 255, 255);\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.8em;\r\n  margin-left: 10px;\r\n}\r\n\r\n.form button:hover {\r\n  background-color: #6d7985;\r\n}\r\n\r\n.profile-display {\r\n  margin-top: 20px;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.btn {\r\n  padding: 8px 15px;\r\n  margin: 5px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n}\r\n\r\n.update-btn {\r\n  background-color: #4CAF50;\r\n  color: white;\r\n}\r\n\r\n.delete-btn {\r\n  background-color: #f44336;\r\n  color: white;\r\n}\r\n\r\n.cancel-btn {\r\n  background-color: #f0f0f0;\r\n  color: black;\r\n}\r\n\r\n.btn:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.publication-list {\r\n  font-size: 0.9em;\r\n  position: relative; /* Ensure relative positioning for absolute children */\r\n}\r\n\r\n.publication-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-bottom: 1px solid #231d73;\r\n  padding: 5px;\r\n}\r\n\r\n.publication-details {\r\n  flex-grow: 1;\r\n}\r\n\r\n.publication-controls {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.add-btn {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  font-size: 20px;\r\n  line-height: 20px;\r\n  padding: 0;\r\n  position: absolute;\r\n  right: 20px;\r\n  bottom: 10px;\r\n  background-color: #4CAF50;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.add-btn:hover {\r\n  background-color: #3e8e41;\r\n}\r\n\r\n\r\n/* ... previous CSS styles ... */\r\n\r\n.publication-list {\r\n  font-size: 0.9em;\r\n  position: relative; /* Ensure relative positioning for absolute children */\r\n  padding-bottom: 40px; /* Add padding to accommodate the '+' button */\r\n}\r\n\r\n.publication-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-bottom: 1px solid #5d5b83;\r\n  padding: 5px;\r\n}\r\n\r\n.publication-details {\r\n  flex-grow: 1;\r\n}\r\n\r\n.publication-controls {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n/* Modifications for the plus button */\r\n.add-btn {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100px; /* Adjusted width for a rectangle shape */\r\n  height: 35px; /* Height for the rectangle */\r\n  border-radius: 4px; /* Less rounded corners */\r\n  font-size: 20px;\r\n  line-height: 15px;\r\n  padding: 10;\r\n  position: absolute;\r\n  right: 20px;\r\n  bottom: 10px;\r\n  background-color: #ffffff; /* Blue background */\r\n  color: white;\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\n.add-btn:hover {\r\n  background-color: #fafdff; /* Darker blue for hover effect */\r\n}\r\n\r\n/* Ensure there is enough space at the bottom of the publication list for the button */\r\n.publication-list {\r\n  padding-bottom: 50px; /* Adjust padding to accommodate the button */\r\n}\r\n\r\n/* Styling for both Add and Modify modals */\r\n.modal {\r\n  position: fixed;\r\n  top: 10%;\r\n  left: 25%;\r\n  right: 25%;\r\n  background-color: rgb(157, 117, 117);\r\n  padding: 20px;\r\n  border: 1px solid rgb(110, 63, 63);\r\n  box-shadow: 0px 0px 10px rgba(3, 0, 0, 0.841);\r\n  overflow: auto; /* Allows scrolling if content is too long */\r\n  max-height: 80%; /* Maximum height */\r\n  resize: both; /* Make the modal resizable */\r\n  z-index: 1000; /* Ensure it's above other elements */\r\n}\r\n\r\n.modal h3 {\r\n  margin-top: 1;\r\n}\r\n\r\n.modal textarea {\r\n  width: 100%;\r\n  min-height: 500px;\r\n  margin-top: 100px;\r\n}\r\n\r\n.modal button {\r\n  margin-top: 10px;\r\n}\r\n\r\n/* If using an h3 tag for publication types */\r\nh3 {\r\n  font-size: 1.2em; /* Adjust the size as needed */\r\n  font-weight: bold; /* Makes the text bold */\r\n}\r\n\r\n/* If using a specific class, e.g., .publication-type */\r\n.publication-type {\r\n  font-size: 1em; /* Adjust the size as needed */\r\n  font-weight: bold; /* Makes the text bold */\r\n}\r\n/* Modal for Adding Publications */\r\n.add-publication-modal {\r\n  position: fixed;\r\n  top: 10%;\r\n  left: 25%;\r\n  background-color: white;\r\n  padding: 20px;\r\n  border: 1px solid rgb(90, 62, 62);\r\n  width: 50%;\r\n  box-shadow: 0px 0px 10px rgba(33, 7, 7, 0.77);\r\n}\r\n\r\n/* Text area within the Add Publication Modal */\r\n.add-publication-modal textarea {\r\n  width: 100%;\r\n  min-height: 100px;\r\n  margin-top: 10px;\r\n}\r\n\r\n\r\n\r\n/* FacultyProfileDetails.css */\r\n\r\n/* Style for bold titles in the faculty profile */\r\n.faculty-profile p strong {\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/*Image Hears*/\r\n.faculty-login {\r\n  background-color: #140c3d;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  min-height: 70vh;\r\n}\r\n\r\n.faculty-login h1 {\r\n  font-size: 38px;\r\n  color: #dddae4;\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n\r\n\r\n.container form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.container input[type=\"text\"],\r\n.container input[type=\"password\"] {\r\n  width: 50%;\r\n  padding: 5px;\r\n  margin: 5px 0;\r\n  border: 1px solid #452222;\r\n  border-radius: 5px;\r\n}\r\n\r\n.container button {\r\n  background-color: #193655e0;\r\n  color: #ffffff;\r\n  padding: 7px 15px;\r\n  border: none;\r\n  scroll-padding: 10px;\r\n  margin: 5px 0;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n}\r\n\r\n.container button:hover {\r\n  background-color: #140a34;\r\n}\r\n\r\n\r\n.faculty-login header {\r\n \r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-end; /* Aligns content to the bottom */\r\n    text-align: end; /* Centers the text horizontally */\r\n    background-size: cover; /* Cover the entire header area */\r\n    background-position: center; /* Center the background image */\r\n    height: 200px; /* Increase this value to adjust the height */\r\n    padding: 10px; /* Adjust padding as needed */\r\n  }\r\n\r\n  .faculty-directory header {\r\n    background-image: linear-gradient(rgba(218, 218, 240, 0.322), rgba(0, 0, 0, 0.945)), url('./images/Directory.png');\r\n    \r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: flex-end; /* Aligns content to the bottom */\r\n      text-align: end; /* Centers the text horizontally */\r\n      background-size: cover; /* Cover the entire header area */\r\n      background-position: center; /* Center the background image */\r\n      height: 400px; /* Increase this value to adjust the height */\r\n      padding: 10px; /* Adjust padding as needed */\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.faculty-name {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n}\r\n\r\n.faculty-designation {\r\n  font-size: 14px;\r\n}\r\n\r\n.faculty-department {\r\n  font-size: 14px;\r\n  color: #3e77b4; /* Navy blue */\r\n}\r\n\r\n.faculty-contact p {\r\n  margin: 5px 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.fa-envelope, .fa-phone {\r\n  margin-right: 10px;\r\n}\r\n\r\n.faculty-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.faculty-member {\r\n  flex-basis: calc(33.33% - 10px);\r\n  margin-right: 10px;\r\n  margin-bottom: 20px;\r\n  border-right: 2px solid #cba2a2;\r\n}\r\n\r\n.faculty-member:last-child {\r\n  border-right: none; /* Remove border for the last element */\r\n}\r\n\r\n.filter-section {\r\n  margin-bottom: 20px; /* Adjust as needed for spacing */\r\n}\r\n\r\n.department-select {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #333;\r\n  padding: 5px 10px;\r\n  border-radius: 5px;\r\n  border: 1px solid #542c2c;\r\n}\r\n\r\n.department-select optgroup {\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Custom scrollbar styles */\r\n.department-select::-webkit-scrollbar {\r\n  width: 10px;\r\n}\r\n\r\n.department-select::-webkit-scrollbar-track {\r\n  background: #813737;\r\n}\r\n\r\n.department-select::-webkit-scrollbar-thumb {\r\n  background: #f12222;\r\n}\r\n\r\n.department-select::-webkit-scrollbar-thumb:hover {\r\n  background: #6b38ca;\r\n}\r\n\r\n\r\n\r\n.alphabet-header {\r\n  font-weight: bold;\r\n  font-size: 1.5em;\r\n}\r\n\r\n\r\n.faculty-register {\r\n  margin-top: 100px; /* Adjust the value as needed for the space */\r\n  text-align: center; /* Optional: Center the content */\r\n}\r\n\r\n.faculty-register h2 {\r\n  font-size: 1.5rem; /* Styling for the heading */\r\n  margin-bottom: 20px; /* Space below the heading */\r\n}\r\n\r\n.faculty-register form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px; /* Space between form fields */\r\n  max-width: 400px; /* Limit the form width */\r\n  margin: 0 auto; /* Center the form */\r\n}\r\n\r\n.faculty-register input,\r\n.faculty-register select {\r\n  padding: 10px;\r\n  font-size: 1rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n}\r\n\r\n.faculty-register button {\r\n  padding: 10px 15px;\r\n  font-size: 1rem;\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.faculty-register button:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.faculty-register .role-selection,\r\n.faculty-register .department-selection {\r\n  text-align: left; /* Aligns labels and inputs */\r\n}\r\n\r\n.faculty-register .error-message {\r\n  color: red;\r\n  font-size: 0.9rem;\r\n  margin-top: 10px;\r\n}\r\n\r\n.faculty-register .success-message {\r\n  color: green;\r\n  font-size: 0.9rem;\r\n  margin-top: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
